import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { PageHeader } from "@/components/PageHeader";
import { Section } from "@/components/primitives";
import { getContent, trackEvent } from "@/lib/api";
import { Plus, Minus } from "@phosphor-icons/react";

function Item({ f, open, onToggle, idx }) {
  return (
    <div className="border-b border-white/10" data-testid={`faq-item-${idx}`}>
      <button
        onClick={onToggle}
        className="w-full flex items-center justify-between gap-4 py-5 text-left group"
        data-testid={`faq-question-${idx}`}
      >
        <span className={`text-base md:text-lg font-medium transition-colors ${open ? "text-[#2DD4BF]" : "text-white group-hover:text-[#2DD4BF]"}`}>
          {f.q}
        </span>
        <span className="shrink-0 grid place-items-center h-8 w-8 rounded-full border border-white/10 text-[#94A3B8]">
          {open ? <Minus size={16} /> : <Plus size={16} />}
        </span>
      </button>
      <AnimatePresence initial={false}>
        {open && (
          <motion.div
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.3, ease: "easeInOut" }}
            className="overflow-hidden"
          >
            <p className="pb-5 pr-12 text-[#94A3B8] leading-relaxed" data-testid={`faq-answer-${idx}`}>{f.a}</p>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}

export default function FAQ() {
  const [faqs, setFaqs] = useState([]);
  const [openIdx, setOpenIdx] = useState(0);
  useEffect(() => {
    trackEvent("page_view", { page: "faq" });
    getContent("faqs").then(setFaqs).catch(() => {});
  }, []);
  return (
    <div>
      <PageHeader
        eyebrow="FAQ"
        title="Questions, answered directly."
        sub="Clear answers about what Quantum Scalp is, what Q-Core does, and what to verify before using the platform."
      />
      <Section grid>
        <div className="max-w-3xl mx-auto rounded-2xl border border-white/10 bg-[#0A0B10] px-6 md:px-8" data-testid="faq-accordion">
          {faqs.map((f, i) => (
            <Item key={f.id} f={f} idx={i} open={openIdx === i} onToggle={() => setOpenIdx(openIdx === i ? -1 : i)} />
          ))}
        </div>
      </Section>
    </div>
  );
}
